import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface Herbicide {
  id: string
  herbicide_name: string
  supplier: string
  registration_number: string
}

export async function getHerbicides(options?: AxiosRequestConfig) {
  const { data } = await companiesApi.get<Herbicide[]>(
    apiRoutes.getHerbicides,
    options,
  )

  return data
}
